export interface SpawnExclusionZone {
  readonly position: { readonly x: number; readonly y: number };
  readonly radius: number;
}

export interface SpawnSnakeGeometry extends SpawnExclusionZone {
  readonly body: readonly SpawnExclusionZone[];
}

export const createSnakeSpawnExclusions = (
  snakes: readonly SpawnSnakeGeometry[],
): readonly SpawnExclusionZone[] =>
  snakes.flatMap((snake) => [
    { position: { ...snake.position }, radius: snake.radius },
    ...snake.body.map((segment) => ({
      position: { ...segment.position },
      radius: segment.radius,
    })),
  ]);

export const addSpawnClearance = (
  exclusions: readonly SpawnExclusionZone[],
  clearance: number,
): readonly SpawnExclusionZone[] => {
  if (!Number.isFinite(clearance) || clearance < 0) {
    throw new RangeError("Spawn clearance must be non-negative and finite");
  }
  return exclusions.map((exclusion) => ({
    position: { ...exclusion.position },
    radius: exclusion.radius + clearance,
  }));
};
